import { Tooltip } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import { colors } from '../../../../Constants/Colors';
import { ReportsButton, StyledReportsButtonGroup } from './ReportsButtonGroup.styled';
import useTranslation from 'Hooks/useTranslation';
import { FaPeopleGroup } from 'react-icons/fa6';
import { MdSchool } from 'react-icons/md';

export const ReportsButtonGroup = () => {
  const location = useLocation();
  const history = useHistory();
  const { t2 } = useTranslation('employees_reports');
  const isEmployeesRoute = location.pathname.includes('/reporte/empleados');
  const isCoursesRoute = location.pathname.includes('/reporte/cursos');

  return (
    <StyledReportsButtonGroup variant="contained">
      <Tooltip title={t2('employees_report_tooltip')} placement="bottom" arrow>
        <ReportsButton onClick={() => history.push('/reporte/empleados')}>
          <FaPeopleGroup size={24} color={isEmployeesRoute ? colors.GREEN : colors.GRAY} />
        </ReportsButton>
      </Tooltip>
      <Tooltip title={t2('courses_report_tooltip')} placement="bottom" arrow>
        <ReportsButton onClick={() => history.push('/reporte/cursos')}>
          <MdSchool size={24} color={isCoursesRoute ? colors.GREEN : colors.GRAY} />
        </ReportsButton>
      </Tooltip>
    </StyledReportsButtonGroup>
  );
};
